import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_SCRATCH_PLATE_CREATED_PLATES_QUERY = gql`
  query GetScratchPlateCreatedPlates($id: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    scratchPlate(id: $id) {
      ... on ScratchPlateNode {
        id
        createdPlates {
          ... on ScratchPlateNode {
            id
            name
            createdAt
            width
            height
            plateSchema {
              ... on PlateSchemaNode {
                id
              }
              ...InaccessibleInfoGraphQL
            }
            summary {
              wellStates {
                rowIndex
                columnIndex
              }
            }
            inventoryPlate {
              ... on PlateNode {
                id
              }
              ...InaccessibleInfoGraphQL
            }
          }
          ...InaccessibleInfoGraphQL
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
